// Create the SenderTransactionType enum based on your image
export enum SenderTransactionType {
  INV = 1,
  AROR = 2,
  ARRefund = 3,
  ARDN = 4,
  ARCN = 5,
  BIL = 6,
  APPV = 7,
  APRefund = 8,
  APDN = 9,
  APCN = 10,
  QT = 11,
  SO = 12,
  SINV = 13,
  DO = 14,
  CS = 15,
  SDN = 16,
  SCN = 17,
  PR = 18,
  PO = 19,
  GRN = 20,
  PINV = 21,
  CP = 22,
  PDN = 23,
  PCN = 24,
  CSR = 25,
  CPF = 26
}

// Creeate reverse mapping from ACL key to SenderTransactionType ID
export const REVERSE_ACL_MAP_SENDER_TRANSACTION_TYPE: Record<string, number> = {
  'qt': SenderTransactionType.QT,
  'so': SenderTransactionType.SO,
  'do': SenderTransactionType.DO,
  'inv': SenderTransactionType.INV,
  'aror': SenderTransactionType.AROR,
  'sinv': SenderTransactionType.SINV,
  'sdn': SenderTransactionType.SDN,
  'scn': SenderTransactionType.SCN,
  'cs': SenderTransactionType.CS,
  'csr': SenderTransactionType.CSR,
  'pr': SenderTransactionType.PR,
  'po': SenderTransactionType.PO,
  'grn': SenderTransactionType.GRN,
  'pinv': SenderTransactionType.PINV,
  'pdn': SenderTransactionType.PDN,
  'pcn': SenderTransactionType.PCN,
  'bil': SenderTransactionType.BIL,
  'cp': SenderTransactionType.CP,
  'cpf': SenderTransactionType.CPF,
  'appv': SenderTransactionType.APPV,
  'apdn': SenderTransactionType.APDN,
  'apcn': SenderTransactionType.APCN,
};
